import { Link } from '@tanstack/react-router'
import { ArrowRight } from 'lucide-react'
import type { ComponentProps } from 'react'
import { Button } from '@/components/ui/button'
import { LOCATION_LABELS } from '@/lib/credentials/locations'
import { cn } from '@/lib/utils'

/** Real count, derived from the location reference data so it never drifts. */
export const LOCATION_COUNT = Object.keys(LOCATION_LABELS).length

/**
 * PLACEHOLDER benchmark values shared by the feature story and the use-case
 * panels so they stay consistent — replace with measured numbers (recurring
 * latency/uptime/success benchmark) before launch.
 */
export const BENCHMARKS = {
  roundTrip: '~0.4s',
  uptime: '99.9%',
  successRate: '99%+',
}

export function GetStartedButton({
  size,
  label = 'Get started',
  className,
}: {
  size?: ComponentProps<typeof Button>['size']
  label?: string
  className?: string
}) {
  return (
    <Button asChild size={size} className={cn('group', className)}>
      <Link to="/signup">
        {label}
        <ArrowRight
          data-icon="inline-end"
          className="transition-transform group-hover:translate-x-0.5"
        />
      </Link>
    </Button>
  )
}

export function GridBackdrop() {
  return (
    <div
      aria-hidden
      className="pointer-events-none absolute inset-0 -z-10 [background-image:linear-gradient(to_right,var(--border)_1px,transparent_1px),linear-gradient(to_bottom,var(--border)_1px,transparent_1px)] [background-size:36px_36px] [mask-image:radial-gradient(ellipse_70%_60%_at_60%_30%,black,transparent)] opacity-60"
    />
  )
}

export function SectionHeading({
  eyebrow,
  title,
  description,
}: {
  eyebrow?: string
  title: string
  description?: string
}) {
  return (
    <div className="flex max-w-2xl flex-col gap-3">
      {eyebrow ? (
        <span className="text-sm font-medium text-primary">{eyebrow}</span>
      ) : null}
      <h2 className="text-3xl font-bold tracking-tight text-balance sm:text-4xl">
        {title}
      </h2>
      {description ? (
        <p className="text-muted-foreground text-pretty">{description}</p>
      ) : null}
    </div>
  )
}
